import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ConteoSolicitudesRespuesta {
  conteo: number;
}

export interface ConteoSolicitudesPort {
  contarPendientes(): Observable<ConteoSolicitudesRespuesta>;
}

export const CONTEO_SOLICITUDES_PORT = new InjectionToken<ConteoSolicitudesPort>('ConteoSolicitudesPort');
